import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import {
  Button,
  Card,
  Divider,
  Grid,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from '@material-ui/icons/Search';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import useRequest from "../../../customHooks/useRequest";
import Header from '../../headers/Header';
import Footer from '../../footer/Footer';
const useStyles = makeStyles((theme) => ({
  pageContainer: {
    minHeight: '100%',
    marginTop: '0px'
  },
  root: {
    margin: '20px 20px',
    marginBottom: '50px',
    padding: '20px 20px'
  },
  mainTable: {
    margin: '20px 0 20px'
  },
  title: {
    color: 'var(--gmi-color)',
    textAlign: 'center'
  },
  // backBtn: {
  //   background: 'var(--gmi-color)',
  //   width: '100px',
  //   "&:hover": {
  //     backgroundColor: 'var(--hover-btn)'
  //   },
  //   color: 'white',
  // },
  editBtn: {
    background: 'var(--gmi-color)',
    "&:hover": {
      backgroundColor: 'var(--hover-btn)'
    },
    color: 'white',
    minInlineSize: 'auto',
    padding: '5px'
  },
  divider: {
    backgroundColor: 'var(--gmi-color)',
    height: '5px',
    margin: '10px 0'
  },
  search: {
    verticalAlign: 'baseline'
  },
  searchIc: {
    color: 'var(--search-icon)'
  },
  searchErr: {
    color: 'red',
    fontSize: '0.8em',
    marginLeft: '15px',
    [theme.breakpoints.down('xs')]: {
      display: 'grid',
      margin: '10px auto 15px',
    }
  },
  container: {
    maxHeight: 440
  },
  isAtt : {
    backgroundColor: 'var(--btn-green)',
    color: 'white',
    borderRadius: '5px',
    padding: '5px 8px'
  },
  isNotAtt: {
    backgroundColor: 'var(--btn-grey)',
    color: 'white',
    borderRadius: '5px',
    padding: '5px 8px'
  }
}));

const columnss = [
  { id: "attributed", label: "Att", minWidth: 20, align: "center" },
  { id: "timestamps", label: "timestamps", minWidth: 50, align: "center" },
  { id: "repair/1#_file/Structure version", label: "Structure version", minWidth: 50, align: "center" },
  { id: "repair/2#_identification/Date of creation", label: "Date of creation", minWidth: 60, align: "center" },
  { id: "uuid", label: "UUID", minWidth: 50, align: "center" },
  { id: "customer", label: "Customer", minWidth: 50, align: "center" },
  { id: "workshop", label: "Workshop", minWidth: 50, align: "center" },
  { id: "edit", label: "", minWidth: 50, align: "center" }
];

const Datatable = ({ className , consoleid }) => {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);


  const { data } = useRequest("get", '/repair/'+consoleid);
  const consolesData = data;
 
  const columns = data[0] && Object.keys(data[0]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(+e.target.value);
    setPage(0);
  };

  /*const tableHeaderold = (
    columns.map((column) => (
      <TableCell
        key={column.id}
        align={column.align}
        style={{ minWidth: column.minWidth }}
      >
        {column.label}
      </TableCell>
    ))
  );
*/

const tableHeader = (
  data[0] && columns.slice(2).map((heading)=><th>{heading}</th>)

);


  const mainContent = (
    consolesData
      .filter(data => 
        Object.keys(data).some(key => 
          data[key] ? data[key].toLowerCase().includes(searchTerm.toLowerCase()) : data[key] === null ? null : null
        )
      )
      .map(consoles => {
        
        return (
          <TableRow
            key={consoles.uuid}
            hover
            role="checkbox"
            tabIndex={-1}
          >
             <TableCell>
            <Link className={'a'} to={`/app/divider/${consoles.uuid}`}>
             
                Select
              
            </Link>
          </TableCell>
           {columns.slice(2).map((column)=>
                    <TableCell>{consoles[column]}</TableCell>
                )}
               
        </TableRow>
      );
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  );

  const filteredObj = (
    consolesData.filter(el => 
      Object.keys(el).some(key =>
        el[key] ? el[key].toLowerCase().includes(searchTerm.toLowerCase()) : el[key] === null ? null : null
      )
    )
  );

  return (
    <Fragment>
     
      <div className={clsx(classes.pageContainer, className)}>
        <Card
          className={clsx(classes.root, className)}
          elevation={2}
          
        >
          <Typography
            className={classes.title}
            gutterBottom
            variant="h4"
            component="h1"
          >
            REPAIRS LIST
          </Typography>

          <TextField 
            className={classes.search}
            id="outlined-search" 
            label="Search" 
            type="search" 
            onChange={(e) => {
              setSearchTerm(e.target.value)
            }}
            autoComplete="off"
            InputProps={{
              endAdornment: 
              <InputAdornment position="end">
                <SearchIcon className={classes.searchIc} />
              </InputAdornment>
            }}
            />
          
          { filteredObj.length === 0 ? <span className={classes.searchErr}>No matching results</span> : null }

          <Divider className={classes.divider}/>

          <Grid>
            <Paper className={classes.mainTable}>
              <TableContainer className={classes.container}>
                <Table
                  stickyHeader
                  size="small"
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>
                    <th></th>
                    <th>RepairID</th>
                    <th>Date of cure</th>
                    <th>Hour of cure</th>
                    <th>CycleID</th>
                    <th>Operator</th>
                    <th>Temp. Unit</th>
                    <th>Console S/N</th>
                    <th>Part S/N</th>
                    <th>Part P/N</th>
                    <th>Parnt name</th>
                    <th>Third party</th>
                    <th>Heating Mean</th>
                    <th>Z1 active</th>
                    <th>Z2 active</th>
                    <th>Recipe ID</th>
                    <th>Recipe Name</th>
                    <th>Duration</th>

                    </TableRow>
                  </TableHead>

                  <TableBody>
                    
                    { mainContent }

                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 50, 100]}
                component="div"
                count={filteredObj.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </Paper>
          </Grid>
          {/* <Button className={classes.backBtn} href="/admin/dashboard"> &lt; Back</Button> */}
        </Card>
      </div>
     
    </Fragment>
  )
};

export default Datatable;